
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1908_525)","stroke":"#535353","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1908_525"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    